/**
 * The src of an imported build asset, in one form wherever it runs.
 *
 * Vite's browser bundle resolves an asset import against import.meta.url and
 * produces an absolute URL, its server bundle emits the build assets path, and
 * hydration reads the two as an attribute mismatch on every img built that way.
 * Both go back through the app's own asset base here, which is where Nuxt
 * serves the file from either way, so the string matches and the request does
 * not move.
 */
export function buildAssetSrc(importedUrl: string): string {
  const file = importedUrl.split('/').pop()
  if (!file) return importedUrl
  const { cdnURL, baseURL, buildAssetsDir } = useRuntimeConfig().app
  const base = (cdnURL || baseURL || '/').replace(/\/+$/, '')
  const dir = (buildAssetsDir || '/_nuxt/').replace(/^\/+|\/+$/g, '')
  return `${base}/${dir}/${file}`
}
